(function(){
  function fmt(c){ var n = c / 100; return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
  function init(root){
    if (!root || root.dataset.ready) return; root.dataset.ready = '1';
    var data; try { data = JSON.parse(root.querySelector('[data-pdp-json]').textContent); } catch(e){ return; }
    var variants = data.variants || [];
    var idIn = root.querySelector('[data-pdp-id]'), qtyIn = root.querySelector('[data-pdp-qty]');
    var cur = variants.filter(function(v){ return String(v.id) === idIn.value; })[0] || variants[0];
    var checked = root.querySelector('input[name="fy-bundle"]:checked');
    var qty = checked ? parseInt(checked.dataset.qty, 10) : 1, pct = checked ? parseInt(checked.dataset.pct, 10) : 0;
    var $ = function(s){ return root.querySelector(s); };
    function update(){
      var base = cur.price * qty, fin = Math.round(base * (100 - pct) / 100);
      var cmp = cur.compare_at_price > cur.price ? cur.compare_at_price * qty : (pct > 0 ? base : 0);
      $('[data-pdp-price]').textContent = fmt(fin);
      var c = $('[data-pdp-compare]'), s = $('[data-pdp-save]');
      if (cmp > fin) { c.textContent = fmt(cmp); c.style.display = ''; s.textContent = 'Ahorras ' + fmt(cmp - fin); s.style.display = ''; }
      else { c.style.display = 'none'; s.style.display = 'none'; }
      var bp = $('[data-pdp-btnprice]'); if (bp) bp.textContent = fmt(fin);
      var sp = $('[data-pdp-sprice]'); if (sp) sp.textContent = fmt(fin);
      idIn.value = cur.id; qtyIn.value = qty;
      var atc = $('[data-pdp-atc]'), lab = $('[data-pdp-atc-label]');
      atc.disabled = !cur.available; lab.textContent = cur.available ? data.atc : data.soldout;
      Array.prototype.forEach.call(root.querySelectorAll('.fy-bundle'), function(l){
        var i = l.querySelector('input'), q = parseInt(i.dataset.qty, 10), p = parseInt(i.dataset.pct, 10);
        var b = cur.price * q, f = Math.round(b * (100 - p) / 100);
        l.querySelector('[data-bprice]').textContent = fmt(f);
        var bc = l.querySelector('[data-bcompare]'); bc.textContent = fmt(b); bc.style.display = p > 0 ? 'block' : 'none';
        l.classList.toggle('is-on', i.checked);
      });
    }
    Array.prototype.forEach.call(root.querySelectorAll('input[name="fy-bundle"]'), function(i){
      i.addEventListener('change', function(){ qty = parseInt(i.dataset.qty, 10); pct = parseInt(i.dataset.pct, 10); update(); });
    });
    var optInputs = root.querySelectorAll('[data-opt-index]');
    Array.prototype.forEach.call(optInputs, function(i){
      i.addEventListener('change', function(){
        var sel = [];
        Array.prototype.forEach.call(root.querySelectorAll('[data-opt-index]:checked'), function(x){ sel[parseInt(x.dataset.optIndex, 10)] = x.value; });
        var lab = root.querySelector('[data-opt-label="' + i.dataset.optIndex + '"]'); if (lab) lab.textContent = i.value;
        var m = variants.filter(function(v){ return v.options.every(function(o, k){ return sel[k] === undefined || o === sel[k]; }); })[0];
        if (m) {
          cur = m; update();
          if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', m.id); history.replaceState({}, '', u); }
          if (m.featured_media) goToMedia(m.featured_media.id);
        }
      });
    });
    var rail = $('[data-pdp-rail]');
    function goTo(idx){ if (!rail) return; var it = rail.children[idx]; if (it) rail.scrollTo({ left: it.offsetLeft - rail.offsetLeft, behavior: 'smooth' }); }
    function goToMedia(id){ if (!rail) return; for (var k = 0; k < rail.children.length; k++) if (rail.children[k].dataset.mediaId == id) return goTo(k); }
    Array.prototype.forEach.call(root.querySelectorAll('[data-pdp-thumb]'), function(t){ t.addEventListener('click', function(){ goTo(parseInt(t.dataset.pdpThumb, 10)); }); });
    var bar = $('[data-pdp-satc]'), atcBtn = $('[data-pdp-atc]');
    if (bar && atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(es){ es.forEach(function(e){ var below = e.boundingClientRect.top < 0; bar.classList.toggle('is-on', !e.isIntersecting && below); }); }).observe(atcBtn);
      var sb = $('[data-pdp-sbtn]'); if (sb) sb.addEventListener('click', function(){ if (atcBtn.disabled) return; atcBtn.click(); });
    }
    update();
  }
  function initSound(){
    Array.prototype.forEach.call(document.querySelectorAll('[data-pv-sound]'), function(btn){
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      var box = btn.parentElement;
      var wave = btn.querySelector('[data-wave]'), x = btn.querySelector('[data-x]');
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var vids = Array.prototype.filter.call(box.querySelectorAll('video'), function(v){ return v.offsetParent !== null; });
        var v = vids[0]; if (!v) return;
        var on = v.muted;
        Array.prototype.forEach.call(document.querySelectorAll('video'), function(o){ o.muted = true; });
        v.muted = !on; v.volume = 1; var p = v.play(); if (p && p.catch) p.catch(function(){});
        wave.style.display = on ? '' : 'none'; x.style.display = on ? 'none' : '';
      });
    });
  }
  function all(){ Array.prototype.forEach.call(document.querySelectorAll('[data-pdp]'), init); initSound(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
